export default "__VITE_ASSET__Sylumglu__"